import { render, staticRenderFns } from "./headerItem.vue?vue&type=template&id=1a36c00a&scoped=true&"
import script from "./headerItem.vue?vue&type=script&lang=js&"
export * from "./headerItem.vue?vue&type=script&lang=js&"
import style0 from "./headerItem.vue?vue&type=style&index=0&id=1a36c00a&prod&scoped=true&lang=css&"
import style1 from "./headerItem.vue?vue&type=style&index=1&id=1a36c00a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36c00a",
  null
  
)

export default component.exports